
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M32.734 27.543c-.35.17-.72.309-1.11.428-.34.1-.54.468-.43.806a.641.641 0 00.81.428c.46-.139.89-.308 1.3-.507.32-.16.46-.548.3-.867a.668.668 0 00-.87-.288z"}}),_c('path',{attrs:{"d":"M43.392 13.764l-6.768.926 4.709-6.192a.994.994 0 00-.19-1.394 1.004 1.004 0 00-1.4.189l-5.529 7.267-.59-7.626a.99.99 0 00-1.07-.915.994.994 0 00-.92 1.065l.69 8.89c-1.72-.279-3.39-.09-4.919.588-3.53 1.563-6.369 5.645-8.439 12.116-3.56 11.15-5.139 20.18-4.219 24.162.07.289.26.538.52.667.14.07.3.11.45.11.14 0 .27-.03.4-.08 5.539-2.4 18.747-19.563 21.556-24.5 1.77-3.117 2.3-5.825 1.57-8.045-.58-1.772-1.93-3.156-4.01-4.112l8.44-1.155c.55-.07.93-.577.85-1.125a1.002 1.002 0 00-1.13-.836zm-6.059 7.855c.54 1.643.05 3.873-1.41 6.442-.97 1.692-2.999 4.59-5.459 7.795-3.159.587-6.069-1.354-7.078-2.021a.648.648 0 10-.72 1.075c.97.647 3.54 2.35 6.589 2.35.04 0 .08-.01.12-.01-4.34 5.515-9.639 11.538-12.878 13.778-.12-2.01.17-5.197 1.09-9.597 1.04.797 2.45 1.324 3.759 1.324.08 0 .17 0 .25-.01a.66.66 0 00.62-.677c-.01-.348-.33-.607-.68-.617-1.33.09-2.84-.657-3.62-1.493.69-3.037 1.65-6.591 2.96-10.673.42-1.314.87-2.489 1.35-3.584 1.27 2.14 3.33 3.524 5.889 3.833.03 0 .05.01.08.01a.646.646 0 00.08-1.284c-1.47-.18-4.03-.956-5.36-4.013 1.52-2.986 3.3-4.968 5.31-5.863a6.415 6.415 0 012.62-.558c1.11 0 2.28.269 3.489.816 1.58.737 2.59 1.733 3 2.977z"}})])
          )
        }
      }
    